export const captionStringsForSDKMessages = [
    'CapturedMessage',
    'CenterMessage',
    'HoldParallelMessage',
    'HoldSteadyMessage',
    'RotateMessage',
    'TiltForwardMessage',
    'TiltUpMessage',
    'TutorialDismissMessage',
    'UserInstructionMessage',
    'ZoomInMessage',
    'ZoomOutMessage'
];

const defaultProcessString =
  "_DeviceType_2"+
  "_DoBinarization_"+
  "_DoCropCorrection_"+
  "_DoSkewCorrectionAlt_"+
  "_Do90DegreeRotation_4"+
  "_LoadInlineSetting_[CSkewDetect.convert_to_gray.Bool=1]"+
  "_LoadInlineSetting_[CSkewDetect.scale_image_down.Bool=1]"+
  "_LoadInlineSetting_[CSkewDetect.scale_down_factor.Int=80]"+
  "_LoadInlineSetting_[CSkewDetect.document_size.Int=2]"+
  "_LoadInlineSetting_[CSkewDetect.correct_illumination.Bool=0]"+
  "_DoScaleImageToDPI_400";

export const processingString =
"_DeviceType_2_"+
"_DoBinarization_"+
"_DoCropCorrection_"+
"_DoScaleImageToDPI_500"+
"_DoSkewCorrectionPage_"+
"_DocDimLarge_3.375"+
"_DocDimSmall_2.125"+
"_LoadInlineSetting_[CSkewDetect.correct_illumination.Bool=0]";

export const processingString_noBinarization =
"_DeviceType_2_"+
"_DoCropCorrection_"+
"_DoScaleImageToDPI_500"+
"_DoSkewCorrectionPage_"+
"_DocDimLarge_3.375"+
"_DocDimSmall_2.125"+
"_LoadInlineSetting_[CSkewDetect.correct_illumination.Bool=0]";

export const processingString_noCrop =
"_DeviceType_2_"+
"_DoBinarization_"+
"_DoScaleImageToDPI_500"+
"_DoSkewCorrectionPage_"+
"_DocDimLarge_3.375"+
"_DocDimSmall_2.125"+
"_LoadInlineSetting_"+
"[CSkewDetect.correct_illumination.Bool=0]";

export const processingString_noCrop_noBinarization =
"_DeviceType_2_"+
"_DoScaleImageToDPI_500"+
"_DoSkewCorrectionPage_"+
"_DocDimLarge_3.375"+
"_DocDimSmall_2.125"+
"_LoadInlineSetting_"+
"[CSkewDetect.correct_illumination.Bool=0]";

export const IMAGE_QUALITY = {
  MIN: 'LOW',
  MEDIUM: 'MEDIUM',
  MAX: 'HIGH',
}

export const ORIENTATION = {
  AUTO: 'SelectAutomatically',
  // AUTO: 'Auto',
  LANDSCAPE: 'Landscape',
  PORTRAIT: 'Portrait',
}

export const PAPER_SIZE = {
  AUTO: 'SelectAutomatically',
  // AUTO: 'Auto',
  A3: 'A3',
  A4: 'A4',
  A5: 'A5',
  A6: 'A6',
  B4: 'B4',
  B5: 'B5',
  LEDGER: 'Ledger',
  LEGAL: 'Legal',
  LETTER: 'Letter',
  FOLIO: 'Folio',
  STATEMENT: 'Statement',
  EXECUTIVE: 'Executive',
}

export const COLOR = {
  GREY: 'Grey',
  COLOR: 'Color',
  BLACK_AND_WHITE: 'BlackAndWhite',
}

export const FILE_NAME_FORMAT = [
  'PRINTER_ID',
  'PRINTER_LOCATION',
  'PRINTER_NAME',
  'USER_NAME',
  'WORKFLOW_NAME',
]